let searchParams = new URLSearchParams(window.location.search);

export const valueFilters = {
	searchTerm: "SearchTerm",
	location: "Location",
	radius: "Radius"
}

export const numberFilters = {
	minHours: "MinHours",
	maxHours: "MaxHours",
}

export const multiChoiceFilters = {
	sector: "Sector",
	jobField: "JobField",
	educationLevel: "EducationLevel"
}

export const pageFilter = {
	page: "Page"
}

export const toggleFilters = {
	permanentContract: "PermanentContract"
}

export const loadFromUrl = () => {
	searchParams = new URLSearchParams(window.location.search);
}

export const trySaveToUrl = (resetPages) => {
	let newUrl = window.location.protocol + "//" + window.location.host + window.location.pathname + '?' + searchParams.toString();

	if(newUrl === history.state?.path)
		return false;

	if(resetPages)
	{
		deleteSearchParam(pageFilter.page);
		newUrl = window.location.protocol + "//" + window.location.host + window.location.pathname + '?' + searchParams.toString();
	}

	window.history.pushState(undefined, '', newUrl);
	return true;
}

export const getSearchParam = (key) => {
	return searchParams.get(key);
}

export const getSearchParams = () => {
	return searchParams;
}

export const deleteSearchParam = (key, value) => {
	searchParams.delete(key, value);
}

export const setSearchParam = (key, value) => {
	searchParams.set(key, value);
}

export const appendSearchParam = (key, value) => {
	searchParams.append(key, value);
}

export const clearFilters = () => {
	const clearedFilters = new URLSearchParams();

	// Copy only valueFilters to clearedFilters
	for (const [key, value] of searchParams.entries()) {
      if (Object.values(valueFilters).indexOf(key) > -1) {
		  clearedFilters.set(key, value);
      }
    }

	searchParams = clearedFilters;
}
